import { Model as BaseModel, MeasMode, MeasureVO, VisionVO, WizConstants } from '@wizeoo/akm-compute-lib';
import { UserVO } from '../vo/user/user.vo';
import { CountryVO } from '../vo/locale/country.vo';
import { LanguageVO } from '../vo/locale/language.vo';
import { BusinessUnitVO } from '../vo/core/business-unit.vo';
import { FeatureVO } from '../vo/core/feature.vo';
import { LocaleEngine } from '../manager/locale/locale.engine';
import { BusinessUnitEngine } from '../manager/core/business-unit.engine';
import { UserEngine, UserUpdate } from '../manager/user/user.engine';
import { UserContextService } from '../manager/context/user-context.service';
import { VisionEngine } from '../manager/vision/vision.engine';
import { FreedataEngine } from '../manager/core/freedata.engine';
import { ChronocodeEngine } from '../manager/core/chronocode.engine';
import { ChronocodeVO } from '../vo/core/chronocode.vo';
import { TimeGapVO } from '../vo/core/timegap.vo';
import { ConnectEngine } from '../manager/core/connect.engine';
import { ConnectVO } from '../vo/core/connect.vo';
import { PermissionEngine } from '../manager/permission/permission.engine';
import { BatchEngine } from '../manager/export/batch-engine';
import { FreedataSyncService } from '../command/core/freedatas/freedatasync.service';
import { RoleVO } from '../vo/user/role.vo';
import { ProfileVO } from '../vo/user/profile.vo';
import { FeatureEngine } from '../manager/core/feature.engine';
import { DataMessage } from '../manager/baselines/data.message';
import { DataEngine } from '../manager/baselines/data.engine';
import { FeiEngine, WizColDef } from '../manager/workingdata/fei.engine';
import { ListFieldEngine } from '../manager/workingdata/listfield.engine';
import { WidgetEngine } from '../manager/widgets/widget.engine';
import { AggregateEngine } from '../manager/computer/aggregate-engine';
import { GridAccessors } from '../components/widgets/pivot/renderers/grid-accessors';
import { StyleEngine } from '../manager/workingdata/style.engine';
import { FormatEngine } from '../manager/workingdata/format.engine';
import { DataPack, VisionStepPerimeter } from '@wizeoo/akm-message-lib';
import { IncExcKeyEngine } from '../manager/core/incexckey.engine';
import { IncExcKeyVO } from '../vo/core/incexckey.vo';
import { StyleVO } from '../vo/workingdata/style.vo';
import { ChronocodeTemplateVO } from '../vo/core/chronocode-template.vo';
import { MeasureEngine } from '../manager/workingdata/measure.engine';
import { FreedataFormulaCoreEngine } from '../manager/computer/freedata.formula.core.engine';
import { IWidget } from '../manager/widgets/i-widget';
import { ScenarioEngine } from '../manager/scenarii/scenario.engine';
import { WidgetDataService } from '../command/workingdata/widget-data.service';
import { CompositeEngine } from '../manager/baselines/composite.engine';
import { ExcelExportEngine } from '../manager/export/excel-export.engine';
import { FeiVO } from '../vo/workingdata/fei.vo';
import { IncExcSampleEngine } from '../manager/core/incexc-sample.engine';
import { FreeDataVO } from '../vo/core/freedata.vo';
import { WeightGridEngine } from '../manager/workingdata/wg.engine';
import { WeightGridVO } from '../vo/integration/weightgrid.vo';
import { IWizRoute, WizDatasource } from '@wizeoo/akm-component-lib';
import { SocketMessageEngine } from '../manager/socketio/socket-message.engine';
import { AttachmentService } from '../command/core/attachment/attachment.service';
import { SyncService } from '../command/core/sync/sync.service';
import { EMEngine } from '../manager/entities/entity-modification.engine';
import { PhysicalTemplateEngine } from '../manager/workingzone/physical-template.engine';
import { PhysicalTemplateVO } from '../vo/workingzone/physical-template.vo';
import { TabVO } from '../vo/workingzone/tab.vo';
import { NavigationEngine } from '../manager/routing/navigation.engine';
import { BaseView } from '../framework/views/base-view';
import { TabEngine } from '../manager/tabs/tab.engine';
import { ProfileEngine, ProfileUpdate } from '../manager/user/profile.engine';
import { UserAppEngine } from '../manager/user/user-app.engine';
import { UserApplicationVO } from '../vo/user/user-app.vo';
import { RoleEngine } from '../manager/user/role.engine';
import { LanguageEngine } from '../manager/locale/language.engine';
import { CountryEngine } from '../manager/locale/country.engine';
import { EmVO } from '../vo/em/em.vo';
import { CssRenderVO } from '../vo/workingdata/cssrender.vo';
import { WorkflowEngine } from '../manager/workflow/workflow.engine';
import { WorkcomSyncService } from '../command/workflow/workcomsync.service';
import { MatrixEngine } from '../manager/matrix/matrix.engine';
import { MatrixSyncService } from '../command/matrix/matrixsync.service';
import { AllkeyWebWorker } from '../manager/worker/allkey.web.worker';

/**
 * conteneur de données METIER (données, PAS objets uniques d'IHM NI méthodes statiques)
 * singleton
 * Même s'il existe des managers, les données utilisées sur plusieurs vues DOIVENT se trouver ici
 * Les collections utilisées par plusieurs vues DOIVENT se trouver ici
 * Le manager de ces collections ne fait que des traitements. Ici est la vérité
 */
export class Model extends BaseModel {
  
  public origin: string = 'common';

  constructor() { 
    super();

    // console.log("build allkeyCommonModel", this);
    this.localeEngine = new LocaleEngine(this);
    this.businessUnitEngine = new BusinessUnitEngine(this);
    this.userContextService = new UserContextService(this);
    this.userEngine = new UserEngine(this);
    this.visionEngine = new VisionEngine(this);
    this.measureEngine = new MeasureEngine(this);
    this.weightGridEngine = new WeightGridEngine(this);
    this.freedataEngine = new FreedataEngine(this);
    this.chronocodeEngine = new ChronocodeEngine(this);
    this.connectEngine = new ConnectEngine(this);
    this.permissionEngine = new PermissionEngine(this);
    this.batchEngine = new BatchEngine(this);
    this.featureEngine = new FeatureEngine(this);
    this.dataEngine = new DataEngine(this);
    this.feiEngine = new FeiEngine(this);
    this.listFieldEngine = new ListFieldEngine(this);
    this.widgetEngine = new  WidgetEngine(this);
    this.aggregateEngine = new AggregateEngine(this);
    this.styleEngine = new StyleEngine(this);
    this.formatEngine = new FormatEngine(this);
    this.incExcKeyEngine = new IncExcKeyEngine(this);
    this.freedataFormulaCoreEngine = new FreedataFormulaCoreEngine(this);
    this.scenarioEngine = new ScenarioEngine(this);
    this.compositeEngine = new CompositeEngine(this);
    this.excelExportEngine = new ExcelExportEngine(this);
    this.incExcSampleEngine = new IncExcSampleEngine(this);
    this.physicalTemplateEngine = new PhysicalTemplateEngine(this);
    this.navigationEngine = new NavigationEngine(this);
    this.tabEngine = new TabEngine(this);
    this.roleEngine = new RoleEngine(this);
    this.profileEngine = new ProfileEngine(this);
    this.userAppEngine = new UserAppEngine(this);
    this.countryEngine = new CountryEngine(this);
    this.languageEngine = new LanguageEngine(this);
    this.connectEngine = new ConnectEngine(this);

    this.widgetDataService = new WidgetDataService(this);
    this.syncService = new SyncService(this);
    this.freedataSyncService = new FreedataSyncService(this);
    this.workcomSyncService = new WorkcomSyncService(this);
    this.matrixSyncService = new MatrixSyncService(this);

    this.socketMessageEngine = new SocketMessageEngine(this);
    this.workflowEngine = new WorkflowEngine(this);
    this.matrixEngine = new MatrixEngine(this);
    
    // alimentation des pseudo-statiques
    this.dataMessage = new DataMessage(this);
    this.gridAccessors = new GridAccessors(this);
   
    // on force l'instance, possible création par model akm
    Model._instance = this;
    // alimentation du model sur le AttachmentService
    AttachmentService.getInstance().model = this;
    // alimentation du model sur EMEngine
    EMEngine.model = this;

  }

  // l'instance (unique)
  protected static _instance: Model = null;
  /** accesseur sur l'instance, créa si nécessaire */
  public static getInstance(): Model {
    if (!this._instance) {
      this._instance = new Model();
      console.log('common model instance', this._instance);
    }
    return this._instance;
  }

  /*****************************************************
   * les instances d'engine propres à CE modèle
   *****************************************************/

  /**
   *  gestion des traductions
   * @override
   */
  public get localeEngine(): LocaleEngine {
      return this._localeEngine as LocaleEngine;
  }
  public set localeEngine(value: LocaleEngine) {
      this._localeEngine = value;
  }

  /**
   *  gestion des FD / FDV
   * @override
   */
  public get freedataEngine(): FreedataEngine {
    return this._freedataEngine as FreedataEngine;
  }
  public set freedataEngine(value: FreedataEngine) {
    this._freedataEngine = value;
  }

  /**
   *  gestion des chronocodes
   * @override
   */
  public get chronocodeEngine(): ChronocodeEngine {
      return this._chronocodeEngine as ChronocodeEngine;
  }
  public set chronocodeEngine(value: ChronocodeEngine) {
      this._chronocodeEngine = value;
  }

  /**
   *  gestion des mesures
   * @override
   */
  public get measureEngine(): MeasureEngine {
    return this._measureEngine as MeasureEngine;
  }
  public set measureEngine(value: MeasureEngine) {
      this._measureEngine = value;
  }

  /**
   *  gestion des grilles de poids
   * @override
   */
  public get weightGridEngine(): WeightGridEngine {
      return this._weightGridEngine as WeightGridEngine;
  }
  public set weightGridEngine(value: WeightGridEngine) {
      this._weightGridEngine = value;
  }

  /**
   *  gestion des visions
   * @override
   */
  public get visionEngine(): VisionEngine {
    return this._visionEngine as VisionEngine;
  }
  public set visionEngine(value: VisionEngine) {
    this._visionEngine = value;
  }

  /**
   *  gestion des scenariis
   * @override
   */
  public get scenarioEngine(): ScenarioEngine {
    return this._scenarioEngine as ScenarioEngine;
  }
  public set scenarioEngine(value: ScenarioEngine) {
      this._scenarioEngine = value;
  }

  protected _businessUnitEngine: BusinessUnitEngine = null;
  public get businessUnitEngine(): BusinessUnitEngine {
    return this._businessUnitEngine;
  }
  public set businessUnitEngine(value: BusinessUnitEngine) {
    this._businessUnitEngine = value;
  }

  protected _userEngine: UserEngine = null;
  public get userEngine(): UserEngine {
    return this._userEngine;
  }
  public set userEngine(value: UserEngine) {
    this._userEngine = value;
  }

  protected _userContextService: UserContextService = null;
  public get userContextService(): UserContextService {
    return this._userContextService;
  }
  public set userContextService(value: UserContextService) {
    this._userContextService = value;
  }

  protected _connectEngine: ConnectEngine = null;
  public get connectEngine(): ConnectEngine {
    return this._connectEngine;
  }
  public set connectEngine(value: ConnectEngine) {
    this._connectEngine = value;
  }

  protected _permissionEngine: PermissionEngine = null;
  public get permissionEngine(): PermissionEngine {
    return this._permissionEngine;
  }
  public set permissionEngine(value: PermissionEngine) {
    this._permissionEngine = value;
  }

  protected _batchEngine: BatchEngine = null;
  public get batchEngine(): BatchEngine {
    return this._batchEngine;
  }
  public set batchEngine(value: BatchEngine) {
    this._batchEngine = value;
  }

  protected _featureEngine: FeatureEngine = null;
  public get featureEngine(): FeatureEngine {
    return this._featureEngine;
  }
  public set featureEngine(value: FeatureEngine) {
    this._featureEngine = value;
  }

  /* le gestionnaire de données */
  public get dataEngine(): DataEngine {
      return this._dataEngine as DataEngine;
  }
  public set dataEngine(value: DataEngine) {
      this._dataEngine = value;
  }

  /* le gestionnaire de FEI */
  protected _feiEngine: FeiEngine = null;
  public get feiEngine(): FeiEngine {
    return this._feiEngine;
  }
  public set feiEngine(value: FeiEngine) {
      this._feiEngine = value;
  }

  /* le gestionnaire spécifique pour les éléments de type list */
  protected _listFieldEngine: ListFieldEngine = null;
  public get listFieldEngine(): ListFieldEngine {
    return this._listFieldEngine;
  }
  public set listFieldEngine(value: ListFieldEngine) {
      this._listFieldEngine = value;
  }

  /* le gestionnaire spécifique pour les éléments de type list */
  protected _widgetEngine: WidgetEngine = null;
  public get widgetEngine(): WidgetEngine {
    return this._widgetEngine;
  }
  public set widgetEngine(value: WidgetEngine) {
      this._widgetEngine = value;
  }

  protected _aggregateEngine: AggregateEngine = null;
  public get aggregateEngine(): AggregateEngine {
    return this._aggregateEngine;
  }
  public set aggregateEngine(value: AggregateEngine) {
      this._aggregateEngine = value;
  }

  protected _styleEngine: StyleEngine = null;
  public get styleEngine(): StyleEngine {
    return this._styleEngine;
  }
  public set styleEngine(value: StyleEngine) {
      this._styleEngine = value;
  }

  protected _formatEngine: FormatEngine = null;
  public get formatEngine(): FormatEngine {
    return this._formatEngine;
  }
  public set formatEngine(value: FormatEngine) {
      this._formatEngine = value;
  }

  protected _incExcKeyEngine: IncExcKeyEngine = null;
  public get incExcKeyEngine(): IncExcKeyEngine {
    return this._incExcKeyEngine;
  }
  public set incExcKeyEngine(value: IncExcKeyEngine) {
      this._incExcKeyEngine = value;
  }

  /* calculs sur les FreedataValue */
  protected _freedataFormulaCoreEngine: FreedataFormulaCoreEngine = null;
  public get freedataFormulaCoreEngine(): FreedataFormulaCoreEngine {
    return this._freedataFormulaCoreEngine;
  }
  public set freedataFormulaCoreEngine(value: FreedataFormulaCoreEngine) {
      this._freedataFormulaCoreEngine = value;
  }

  protected _compositeEngine: CompositeEngine = null;
  public get compositeEngine(): CompositeEngine {
    return this._compositeEngine;
  }
  public set compositeEngine(value: CompositeEngine) {
      this._compositeEngine = value;
  }

  protected _excelExportEngine: ExcelExportEngine = null;
  public get excelExportEngine(): ExcelExportEngine {
    return this._excelExportEngine;
  }
  public set excelExportEngine(value: ExcelExportEngine) {
      this._excelExportEngine = value;
  }

  protected _incExcSampleEngine: IncExcSampleEngine = null;
  public get incExcSampleEngine(): IncExcSampleEngine {
    return this._incExcSampleEngine;
  }
  public set incExcSampleEngine(value: IncExcSampleEngine) {
      this._incExcSampleEngine = value;
  }

  protected _physicalTemplateEngine: PhysicalTemplateEngine = null;
  public get physicalTemplateEngine(): PhysicalTemplateEngine {
    return this._physicalTemplateEngine;
  }
  public set physicalTemplateEngine(value: PhysicalTemplateEngine) {
      this._physicalTemplateEngine = value;
  }

  protected _navigationEngine: NavigationEngine = null;
  public get navigationEngine(): NavigationEngine {
    return this._navigationEngine;
  }
  public set navigationEngine(value: NavigationEngine) {
      this._navigationEngine = value;
  }

  protected _tabEngine: TabEngine = null;
  public get tabEngine(): TabEngine {
    return this._tabEngine;
  }
  public set tabEngine(value: TabEngine) {
      this._tabEngine = value;
  }

  protected _roleEngine: RoleEngine = null;
  public get roleEngine(): RoleEngine {
    return this._roleEngine;
  }
  public set roleEngine(value: RoleEngine) {
      this._roleEngine = value;
  }

  protected _profileEngine: ProfileEngine = null;
  public get profileEngine(): ProfileEngine {
    return this._profileEngine;
  }
  public set profileEngine(value: ProfileEngine) {
      this._profileEngine = value;
  }

  protected _userAppEngine: UserAppEngine = null;
  public get userAppEngine(): UserAppEngine {
    return this._userAppEngine;
  }
  public set userAppEngine(value: UserAppEngine) {
      this._userAppEngine = value;
  }

  protected _languageEngine: LanguageEngine = null;
  public get languageEngine(): LanguageEngine {
    return this._languageEngine;
  }
  public set languageEngine(value: LanguageEngine) {
    this._languageEngine = value;
  }

  protected _countryEngine: CountryEngine = null;
  public get countryEngine(): CountryEngine {
    return this._countryEngine;
  }
  public set countryEngine(value: CountryEngine) {
    this._countryEngine = value;
  }

  protected _widgetDataService: WidgetDataService = null;
  public get widgetDataService(): WidgetDataService {
    return this._widgetDataService;
  }
  public set widgetDataService(value: WidgetDataService) {
      this._widgetDataService = value;
  }

  protected _syncService: SyncService = null;
  public get syncService(): SyncService {
    return this._syncService;
  }
  public set syncService(value: SyncService) {
    this._syncService = value;
  }

  protected _freedataSyncService: FreedataSyncService = null;
  public get freedataSyncService(): FreedataSyncService {
    return this._freedataSyncService;
  }
  public set freedataSyncService(value: FreedataSyncService) {
    this._freedataSyncService = value;
  }

  protected _workcomSyncService: WorkcomSyncService = null;
  public get workcomSyncService(): WorkcomSyncService {
    return this._workcomSyncService;
  }
  public set workcomSyncService(value: WorkcomSyncService) {
    this._workcomSyncService = value;
  }

  protected _matrixSyncService: MatrixSyncService = null;
  public get matrixSyncService(): MatrixSyncService {
    return this._matrixSyncService;
  }
  public set matrixSyncService(value: MatrixSyncService) {
    this._matrixSyncService = value;
  }

  protected _socketMessageEngine: SocketMessageEngine = null;
  public get socketMessageEngine(): SocketMessageEngine {
    return this._socketMessageEngine;
  }
  public set socketMessageEngine(value: SocketMessageEngine) {
    this._socketMessageEngine = value;
  }


  public get workflowEngine(): WorkflowEngine {
    return this._workflowEngine as WorkflowEngine;
  }
  public set workflowEngine(value: WorkflowEngine) {
    this._workflowEngine = value;
  }

  public get matrixEngine(): MatrixEngine {
    return this._matrixEngine as MatrixEngine;
  }
  public set matrixEngine(value: MatrixEngine)  {
    this._matrixEngine = value;
  }

   /***************************
   * les pseudo statiques
   ***************************/ 

  // la classe porteuse des messages de chargement (initiaux)
  public dataMessage: DataMessage = null;
  // la classe porteuse des messages de chargement (initiaux)
  public gridAccessors: GridAccessors = null;

  /***************************
   * Clés d'unicité
   ***************************/ 
  // user connecté en mode VO
  private _connectedUser: UserVO = null; // l'utilisateur connecté
  public get connectedUser(): UserVO {
    return this._connectedUser;
  }
  public set connectedUser(value: UserVO) {
    this._connectedUser = value;
  }

  
  /***************************
   * Données au domaine
   ***************************/
  // liste des BUs
  private _businessUnitList: BusinessUnitVO[] = null; 
  public get businessUnitList(): BusinessUnitVO[] {
    return this._businessUnitList;
  }
  public set businessUnitList(value: BusinessUnitVO[]) {
    this._businessUnitList = value;
  }
  // map de BUs par code domaine
  private _businessUnitMap: Map<string, BusinessUnitVO[]> = null; 
  public get businessUnitMap(): Map<string, BusinessUnitVO[]> {
    return this._businessUnitMap;
  }
  public set businessUnitMap(value: Map<string, BusinessUnitVO[]>) {
    this._businessUnitMap = value;
  }
  // pool de visions pour le domaine complet
  public get visions(): VisionVO[] {
    return this._visions as VisionVO[];
  }
  public set visions(value: VisionVO[]) {
    this._visions = value;
  }
  // dico de vision map[buCode] = map[code] = visionVO
  public get visionsDic(): Map<string, Map<string, VisionVO>> {
    return this._visionsDic as Map<string, Map<string, VisionVO>>;
  }
  public set visionsDic(value: Map<string, Map<string, VisionVO>>) {
    this._visionsDic = value;
  }

  /***************************
   * Données à la BU
   ***************************/


  /** Map des users par mail: <login, userVO> */
  private _usersMap: Map<string, UserVO> = null;
  public get usersMap(): Map<string, UserVO> {
    return this._usersMap;
  }
  public set usersMap(value: Map<string, UserVO>) {
    this._usersMap = value;
  }


  // Liste de tous les pays
  private _countryList: CountryVO[] = null; 
  public get countryList(): CountryVO[] {
    return this._countryList;
  }
  public set countryList(value: CountryVO[]) {
    this._countryList = value;
  }

  // Chargement au démarrage de l'appli : les pays + leurs langues
  private _countryMap: Map<string, CountryVO> = null;
  public get countryMap(): Map<string, CountryVO> {
    return this._countryMap;
  }
  public set countryMap(value: Map<string, CountryVO>) {
    this._countryMap = value;
  }

  // Liste de toutes les langues
  private _languageList: LanguageVO[] = null; 
  public get languageList(): LanguageVO[] {
    return this._languageList;
  }
  public set languageList(value: LanguageVO[]) {
    this._languageList = value;
  }

  /** Map de language key = code */
  private _languageMap: Map<string, LanguageVO> = null; 
  public get languageMap(): Map<string, LanguageVO> {
    return this._languageMap;
  }
  public set languageMap(value: Map<string, LanguageVO>) {
    this._languageMap = value;
  }

  // map des fonctionnalités, à la bu, code
  private _featureMap: Map<string, Map<string, FeatureVO>> = null; 
  public get featureMap(): Map<string, Map<string, FeatureVO>> {
    return this._featureMap;
  }
  public set featureMap(value: Map<string, Map<string, FeatureVO>>) {
    this._featureMap = value;
  }

  /** Map de la liste des rôles par bu / vision pour AKM */
  public rolesMap: Map<string, Map<string, Map<string, RoleVO>>> = null; 
    /** 
   * Map de la liste des rôles par clé pour AKDOM 
   * [domain, bu, vision, code]
   */
  public rolesFastMap: Map<string, RoleVO> = null; 


  /** Map de profiles par bu / vision = code pour AKM */
  public profileMap: Map<string, Map<string, Map<string, ProfileVO>>> = null; 
  /** 
   * Map de la liste des profiles par clé pour AKDOM 
   * [domain, bu, vision, code]
   */
  public profileFastMap: Map<string, ProfileVO> = null; 

  // liste des chronocodes de niveau 1 (utilisables). Ils contiennent leurs enfants
  public chronocodeTreeList: ChronocodeVO[] = null;
 
  // Liste des périodes de découpage des chronocodes
  public timegapList: TimeGapVO[] = null; 

  // map des fonctions Connect. A la BU => codeCnx => ConnectVO
  public connectMapExt: Map<string, Map<string, Map<string, ConnectVO>>> = null; 

  // dico de vsp map[buCode] = map[visionCode] = code => VisionStepPerimeter
  public visionStepPerimetersDic: Map<string, Map<string, Map<string, VisionStepPerimeter>>> = null;

  // dico de include/exc map[buCode] = map[uniqueKey] = IncExcKeyVO
  public incExcKeyDic: Map<string, Map<string, Map<string, IncExcKeyVO>>> = null; 
  // pool de travail
  public incExcKeyCollection: IncExcKeyVO[] = null; 

  public styleList: StyleVO[] = null;
  // map des styles: vision  = code = StyleVO
  public styleMap: Map<string, Map<string, StyleVO>> = null; 

  public cssrenderList: CssRenderVO[] = null;
  // map des styles: vision  = code = CssRenderVO
  public cssrenderMap: Map<string, Map<string, CssRenderVO>> = null; 

  /******************************************************
   * mémorisation des éléments de travail
   ******************************************************/

  /** Le chronocode en cours d'EDITION dans la vue Chronocode elements */
  public currentChronocode: ChronocodeVO = null;
  /** le clone de travail du chronocode en cours de sélection */
  public cloneChronocode: ChronocodeVO = null;

  // template de chronocode en cours de création
  public chronoCodeTemplate: ChronocodeTemplateVO = null;
  // measure en cours pour la vue mesure
  public currentMeasure: MeasureVO = null;

  /**
   * map des fonctions connect par widget par colDef
   * TODO TODO prévoir reset;
   */
  public connectWidgetMap: Map<IWidget, Map<WizColDef, ConnectVO>> = new Map();

  /** datasource des measures (toutes visions confondues, tous les steps ???) */
  public measureDS: WizDatasource<MeasureVO> = new WizDatasource<MeasureVO>([])
    .setSelectionMode('multiple')
    .setSortFields([
      { property: 'code', way: 'asc' },
      { property: 'formulaI', way: 'asc' },
    ])
    .build();
  
  /** les erreurs en cours sur la vue mesure */
  public errorMMs: Map<string, MeasMode> = null;
  /** liste des mesures en cours pour calcul de matrice */
  public visionMeasures: MeasureVO[] = null;
  /** le mode de measure en cours de travail */
  public currentFistMode: string = WizConstants.MEASURE_MODE_INTERACT;
  /** le niveau de step en cours d'édition */
  public currentStepLevel: number = 0;
  /** le fei calculé pour le niveau de step en cours */
  public currentMeasureFEI: FeiVO = null;

  /**
   * FD en cours d'édition
   */
  public currentEditedFreedata: FreeDataVO = null;
  
  // WG en cours, sert aussi de flag pour afficher le détail / le cartouche
  public currentWG: WeightGridVO = null; 
  // le clone de travail
  public cloneWG: WeightGridVO = null; 

  // Collections des tabs custom du user
  public tabsCollection: TabVO[]; 


  // clone du template en cours de modifs
  public workingTemplateClone: PhysicalTemplateVO = null; 

  // Map des physical templates par bu = vision = code = template
  public physicalTemplateMap: Map<string, Map<string, Map<string, PhysicalTemplateVO>>>; 
  /** colletion de modèles de vues */ 
  public physicalTemplateCollection: PhysicalTemplateVO[]; 

  // map de vues en cours d'affichage pour l'app
  public currentViews: Map<string, BaseView> = new Map<string, BaseView>(); 

  // les routes de l'appli, pour gestion des tabs. Alimenté par l'appModule
  public routes: IWizRoute[];
  
  // la vue "préférée", pour ajout systématique aux tabs
  public favoriteRoute: string;

  /** le profil édité */
  public currentEditedProfile: ProfileVO = null;


  /******************************************************
   * mémorisation des éléments de travail, DOM
   ******************************************************/
  
  // le code du domain en cours de manip (DOM)
  public currentDomainCode: string = null; 

  // le code de la BU en cours de manip (DOM)
  public currentBUCode: string = null; 

  // périmètre en cours dans la vue des profiles / des users.roles
  public currentApplication: UserApplicationVO;
  
  // idem, mais la vraie conf pour le user
  public currentUserApplication: UserApplicationVO;
  

  /**
   * Liste des users mis à jour et de leurs apps modifiées
   * clé = user.mail
   */
  public userUpdates: Map<string, UserUpdate>;

  /** la BU en cours d'EDITION dans la vue BU (pas la BU du user) */
  public currentEditedBusinessUnit: BusinessUnitVO = null;

  /** le dernier role édité */
  public currentEditedRole: RoleVO = null;
  public currentSelectedFeature: FeatureVO = null;

  /** la langue en cours d'EDITION dans la vue language (pas la language du user) */
  public currentEditedLanguage: LanguageVO = null;

  /** le dernier pays édité */
  public currentEditedCountry: CountryVO = null;

  /** le profil édité */
  // idem AKM public currentEditedProfile: ProfileVO = null;

  /**
   * liste des modification sur le profil en cours d'édition
   * clé = profil.key (profile.engine.getProfileKey)
   */
  public profileUpdates: Map<string, ProfileUpdate>;

  /** TODO traçabilité pour mode offline la collection des Ems depuis l'ouverture de session */
  public ems: EmVO[] = []; 

  /**
   * map des commits reçus par numRev(de retour) pour éviter la double synchro
   */
  public commitMap: Map<number, DataPack> = new Map();

}
